export default __webpack_public_path__ + "static/media/georgiab.0430236c.ttf";